import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { showToast } from '../Modais/Toast';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faLockOpen, faArrowUp, faArrowDown, faKey, faCircleNotch } from '@fortawesome/free-solid-svg-icons';





const Ferramentas = ({ showToast}) => {
  const [activeTab, setActiveTab] = useState('criptografia'); // 'criptografia' ou 'transferencia'
  // Estados para a aba de criptografia
  const [textoEntrada, setTextoEntrada] = useState('');
  const [textoSaida, setTextoSaida] = useState('');
  const [segredo, setSegredo] = useState('');
  const [algoritmoCriptografia, setAlgoritmoCriptografia] = useState("novo");
  const [saida, setSaida] = useState('');

  // Estados para a aba de transferência rápida
  const [mensagemTransferencia, setMensagemTransferencia] = useState('');
  const [mensagensRecebidas, setMensagensRecebidas] = useState([]);
  const [codigoAcesso, setCodigoAcesso] = useState('');
  const [novoCodigo, setNovoCodigo] = useState('');
  

  const getCookie = (nome) => {
    const match = document.cookie.match(new RegExp('(^| )' + nome + '=([^;]+)'));
    return match ? match[2] : null;
  };


  const criptografar = async (opcao) => {
    if (!getCookie('info')) {
      await Swal.fire({ text: 'Sua sessão expirou!', icon: 'error' });
      return window.location.href = '/';
    }

    var token_autorizado = getCookie("info")

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/codificar/acao`, {
        method: 'POST',
        headers: {
            'Authority': token_autorizado,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            textoEntrada: textoEntrada, 
            chave: segredo, 
            opcao: opcao,
            algoritmo: algoritmoCriptografia})
      });

      const result = await response.json();
      if (result.status === 'erro') {
        await Swal.fire({ text: result.mensagem, icon: 'error' });
      } else {
        setTextoSaida(result.texto);
      }
    } catch (err) {
      console.error('Erro ao criptografar:', err);
    }
  };

  const criptografiaLegado = async (acao) => {
  const input = JSON.stringify({ 
    acao, 
    texto: textoEntrada.replace(/[#+&¨]/g, (char) => 
      ({
        '#': '%23',
        '+': '%2B',
        '&': '%26',
        '¨': '%A8'
      })[char] || char 
    ) 
  });
    const url = `https://gates.processoagil.com/manutencao/WSInfra.asmx/Criptografia?input=${input}`;
    const response = await fetch(url);
    const data = await response.text();
    const parsed = JSON.parse(new window.DOMParser().parseFromString(data, 'text/xml').querySelector('string').textContent);
    setTextoSaida(parsed.texto);
  };

  const gerarAcao = (opcao) => {
    if (algoritmoCriptografia === 'novo') return criptografar(opcao);
    if (algoritmoCriptografia === 'legado') return criptografiaLegado(opcao === 'criptografar' ? 'codificar' : 'decodificar');
    if (algoritmoCriptografia === 'cookie') return criptografiaLegado(opcao === 'criptografar' ? 'codificar_cookie' : 'decodificar_cookie');
    if (algoritmoCriptografia === 'source') return criptografar(opcao); 
  };

  const gerarSenhaAleatoria = () => {
    const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJLMNOPQRSTUVWXYZ!@#$%^*+?:"';
    let senha = '';
    for (let i = 0; i < 16; i++) {
      senha += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setTextoSaida(senha);
  };

  const converterMinuscula = () => setTextoSaida(textoEntrada.toLowerCase());
  const converterMaiuscula = () => setTextoSaida(textoEntrada.toUpperCase());

  const formatarJson = () => {
    try {
      const jsonString = textoEntrada
            .replace(/ObjectId\("([a-fA-F0-9]+)"\)/g, '"ObjectId(\'$1\')"')
            .replace(/ISODate\("([^"]+)"\)/g, '"ISODate(\'$1\')"')
            .replace(/NumberLong\("?([0-9]+)"?\)/g, '"NumberLong(\'$1\')"')
            .replace(/NumberInt\("?([0-9]+)"?\)/g, '"NumberInt(\'$1\')"');

      const objeto = JSON.parse(jsonString);

      const jsonFormatado = JSON.stringify(objeto, null, 4);

      const jsonFinal = jsonFormatado 
          .replace(/"ObjectId\('([a-fA-F0-9]+)'\)"/g, 'ObjectId("$1")')
          .replace(/"ISODate\('([^']+)'\)"/g, 'ISODate("$1")')
          .replace(/"NumberLong\('([0-9]+)'\)"/g, 'NumberLong($1)')
          .replace(/"NumberInt\('([0-9]+)'\)"/g, 'NumberInt($1)');
      
      setTextoSaida(jsonFinal);
    } catch (e) {
      setTextoSaida(`❌ JSON inválido: ${e.message}`);
    }
  }

  function limparObjectId(texto) {
    return texto.replace(/ObjectId\(["']?([a-f0-9]{24})["']?\)/gi, '"$1"');
  }

  function converterFormato(tipo) {
    try {
      if (tipo === 'json-csv') {

        const entradaLimpa = textoEntrada
              .replace(/ObjectId\("([a-fA-F0-9]+)"\)/g, '"ObjectId(\'$1\')"')
              .replace(/ISODate\("([^"]+)"\)/g, '"ISODate(\'$1\')"')
              .replace(/NumberLong\("?([0-9]+)"?\)/g, '"NumberLong(\'$1\')"')
              .replace(/NumberInt\("?([0-9]+)"?\)/g, '"NumberInt(\'$1\')"');

        console.log("Entrada limpa: ", entradaLimpa)

        const dados = JSON.parse(entradaLimpa);

        const array = Array.isArray(dados) ? dados : [dados];

        if (array.length === 0) {
          setTextoSaida('⚠️ JSON vazio.');
          return;
        }

        const colunas = Object.keys(array[0]);

        const csv = [
          colunas.join(', '), // cabeçalhos
          ...array.map(obj =>
            colunas.map(campo => (obj[campo] !== undefined ? obj[campo] : '')).join(', ')
          )
        ].join('\n');

        const jsonRestaurado = csv 
            .replace(/"ObjectId\('([a-fA-F0-9]+)'\)"/g, 'ObjectId($1)')
            .replace(/"ISODate\('([^']+)'\)"/g, 'ISODate("$1")')
            .replace(/"NumberLong\('([0-9]+)'\)"/g, 'NumberLong($1)')
            .replace(/"NumberInt\('([0-9]+)'\)"/g, 'NumberInt($1)');

        setTextoSaida(jsonRestaurado);

      } else if (tipo === 'csv-json') {
        const separador = textoEntrada.includes('\t') ? '\t' : ','; // detecta TAB ou vírgula
        const linhas = textoEntrada.trim().split('\n');

        if (linhas.length < 2) {
            setTextoSaida('⚠️ CSV inválido.');
            return;
        }

        const cabecalhos = linhas[0].split(separador);
        
        const json = linhas.slice(1).map(linha => {
            const valores = linha.split(separador);
            const obj = {};
            cabecalhos.forEach((campo, i) => {
                let valor = valores[i]?.trim();

                // 🔥 Detectar e ajustar tipos especiais
                if (/^ObjectId\(['"]?([a-fA-F0-9]{24})['"]?\)$/i.test(valor)) {
                    valor = `ObjectId("${valor.match(/[a-fA-F0-9]{24}/)[0]}")`;
                } else if (/^ISODate\(['"]?(.+?)['"]?\)$/i.test(valor)) {
                    const data = valor.match(/ISODate\(['"]?(.+?)['"]?\)/)[1];
                    valor = `ISODate("${data}")`;
                } else if (/^NumberLong\(['"]?(\d+)['"]?\)$/i.test(valor)) {
                    const numero = valor.match(/\d+/)[0];
                    valor = `NumberLong(${numero})`;
                } else if (/^NumberInt\(['"]?(\d+)['"]?\)$/i.test(valor)) {
                    const numero = valor.match(/\d+/)[0];
                    valor = `NumberInt(${numero})`;
                } else if (/^[a-fA-F0-9]{24}$/.test(valor)) {
                    // Se for ObjectId puro (sem função)
                    valor = `ObjectId("${valor}")`;
                } else if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/.test(valor)) {
                    // ISODate pura (sem função)
                    valor = `ISODate("${valor}")`;
                } else if (/^\d+$/.test(valor)) {
                    // Números inteiros simples (NumberLong)
                    valor = `NumberLong(${valor})`;
                }
                // } else {
                //     //valor = ${valor}; // mantém como string comum
                // }

                obj[campo.trim()] = valor;
            });
            return obj;
        });

        const jsonString = JSON.stringify(json, null, 4);

        const jsonSemBarras = jsonString.replace(/\\"/g, '"');

        const jsonRestaurado = jsonSemBarras
            .replace(/"ObjectId\((.*?)\)"/g, '$1')
            .replace(/"ISODate\((.*?)\)"/g, '$1')
            .replace(/"NumberLong\((.*?)\)"/g, '$1')
            .replace(/"NumberInt\((.*?)\)"/g, '$1');

        setTextoSaida(jsonRestaurado);
        
      }
    } catch (e) {
      setTextoSaida(`❌ Erro ao converter: ${e.message}`);
    }
  }

 
 //------------------------- Funções para a área de transferência rápida----------------------------//
//  const gerarCodigo = () => {
//   const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
//   let codigo = '';
//   for (let i = 0; i < 6; i++) {
//     codigo += chars.charAt(Math.floor(Math.random() * chars.length));
//   }
//   setNovoCodigo(codigo);
// };

// const compartilharMensagem = () => {
//   if (!mensagemTransferencia.trim()) {
//     showToast('Digite uma mensagem para compartilhar', 'error');
//     return;
//   }
  
//   if (!novoCodigo) {
//     showToast('Gere um código primeiro', 'error');
//     return;
//   }
  
//   // Simulando armazenamento no localStorage (em um caso real, seria uma API)
//   localStorage.setItem(`transferencia_${novoCodigo}`, mensagemTransferencia);
//   showToast(`Mensagem compartilhada com código: ${novoCodigo}`, 'success');
//   setMensagemTransferencia('');
// };

// const buscarMensagem = () => {
//   if (!codigoAcesso.trim()) {
//     showToast('Digite um código para buscar', 'error');
//     return;
//   }
  
//   // Simulando busca no localStorage (em um caso real, seria uma API)
//   const mensagem = localStorage.getItem(`transferencia_${codigoAcesso}`);
  
//   if (mensagem) {
//     setMensagensRecebidas(prev => [...prev, { codigo: codigoAcesso, mensagem }]);
//     showToast('Mensagem encontrada!', 'success');
//   } else {
//     showToast('Nenhuma mensagem encontrada para este código', 'error');
//   }
  
//   setCodigoAcesso('');
// };

  return (
    <div className="ferramentas-container">
      {/* <div className='tabs-menu'>
        <button 
          className={activeTab === 'criptografia' ? 'active' : ''}
          onClick={() => setActiveTab('criptografia')}
        >
          <FontAwesomeIcon icon={faLock} /> Ferramentas
        </button>
        <button 
          className={activeTab === 'transferencia' ? 'active' : ''}
          onClick={() => setActiveTab('transferencia')}
        >
          <FontAwesomeIcon icon={faExchangeAlt} /> Transferência Rápida
        </button>
      </div> */}
        {activeTab === 'criptografia' && (
          <>
            <div className="form-bloco">
                <textarea
                id="entrada"
                className="form-control"
                rows="4"
                placeholder="Texto de entrada"
                value={textoEntrada}
                onChange={(e) => setTextoEntrada(e.target.value)}
               
                />
                {/* <div className="character-counter-ferramenta">
                  {textoEntrada.length}/1000 caracteres
                </div> */}
            </div>

            <div className="form-bloco">
                <input
                    className="form-control"
                    type="text"
                    placeholder="Segredo"
                    value={segredo}
                    onChange={(e) => {
                      if (e.target.value.length > 100) {
                          showToast("O segredo não pode ter mais de 100 caracteres", "warning");
                          return; // Impede a atualização se exceder
                      }
                      setSegredo(e.target.value)
                    }}
                />
            </div>
        
            <div className="acoes-container">
                <button onClick={() => gerarAcao("criptografar")}>
                    <FontAwesomeIcon icon={faLock} /> Codificar
                </button>

                <button onClick={() => gerarAcao("descriptografar")}>
                    <FontAwesomeIcon icon={faLockOpen} /> Decodificar
                </button>

                <select
                    value={algoritmoCriptografia}
                    onChange={(e) => setAlgoritmoCriptografia(e.target.value)}
                >
                    <option value="" disabled>
                        Selecione a criptografia
                    </option>
                    <option value="novo">Novo</option>
                    <option value="legado">Legado</option>
                    <option value="cookie">Cookie Legado</option>
                    <option value="source">Source</option>
                </select>
            </div>

            <div className="ferramentas-secundarias">
                <button className="btn-maiuscula" onClick={converterMaiuscula}><FontAwesomeIcon icon={faArrowUp} /> Maiúscula</button>
                <button className="btn-minuscula" onClick={converterMinuscula}><FontAwesomeIcon icon={faArrowDown} /> Minúscula</button>
                <button className="btn-senha" onClick={gerarSenhaAleatoria}><FontAwesomeIcon icon={faKey} /> Gerar Senha</button>
                <button className="btn-json" onClick={formatarJson}><FontAwesomeIcon icon={faCircleNotch} /> Formatar JSON</button>
                <button className="btn-json-to-csv" onClick={() => converterFormato('json-csv')}>JSON → CSV</button>
                <button className="btn-csv-to-json" onClick={() => converterFormato('csv-json')}>CSV → JSON</button> 
            </div>

            <div className="form-bloco">
                <textarea
                    id="saida"
                    className="form-control mt-2"
                    rows="4"
                    placeholder="Texto de saída"
                    value={textoSaida}
                    readOnly
                />
            </div>

            <div className="mt-2 d-flex gap-2">
                <button
                    className="btn btn-success"
                    onClick={() => {
                        if (textoSaida.trim() !== "") {
                            navigator.clipboard.writeText(textoSaida).then(() => {});
                            //Swal.fire({ text: 'Texto copiado!', icon: 'error' });
                            showToast('Senha copiada com sucesso!', 'success');
                        }
                    }}
                    >
                    <i className="fas fa-copy"></i> Copiar
                </button>

                <button
                    className="btn btn-secondary"
                    onClick={() => {
                        setTextoSaida("");
                    }}
                >
                    <i className="fas fa-eraser"></i> Limpar
                </button>
            </div>
          </>
        )}

        {/* {activeTab === 'transferencia' && (
          <div className="transferencia-rapida">
            <div className="form-bloco">
              <h4>Compartilhar Mensagem</h4>
              <textarea
                className="form-control"
                rows="3"
                placeholder="Digite a mensagem que deseja compartilhar"
                value={mensagemTransferencia}
                onChange={(e) => setMensagemTransferencia(e.target.value)}
              />
              
              <div className="codigo-gerado">
                <label>Código de compartilhamento:</label>
                <div className="codigo-display">
                  {novoCodigo || 'Nenhum código gerado'}
                  <button onClick={gerarCodigo} className="btn-gerar">
                    Gerar Novo
                  </button>
                  <button 
                    onClick={compartilharMensagem}
                    className="btn btn-primary mt-2"
                  >
                    <FontAwesomeIcon icon={faClipboard} /> Compartilhar
                  </button>
                </div>
              </div>
              
              
            </div>

            <div className="form-bloco">
              <h4>Buscar Mensagem</h4>
              <div className='codigo-e-botao'>
                <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Digite o código recebido"
                      value={codigoAcesso}
                      onChange={(e) => setCodigoAcesso(e.target.value)}
                    />
                </div>
                    <button onClick={buscarMensagem} className="btn btn-success">
                      Buscar
                    </button>
              </div>
              {mensagensRecebidas.length > 0 && (
                <div className="mensagens-recebidas">
                  <h5>Mensagens Recebidas:</h5>
                  {mensagensRecebidas.map((msg, index) => (
                    <div key={index} className="mensagem-item">
                      <div className="mensagem-codigo">Código: {msg.codigo}</div>
                      <div className="mensagem-conteudo">{msg.mensagem}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )} */}
    </div>
  );
};

export default Ferramentas;
